import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AlSection, AlAquaRow } from 'PatientCareCenter/Note/AL';
import styles from './Common.module.css';
import { codeValidForAdmit } from '_helpers';
import { CancelButton, StatusGood } from '_components';


class AlAqua extends React.Component {

    constructor(props) {
        super();
        this.state = {
            showWarning: false
        };
    }

    add() {
        if (this.props.trtValid || (!this.props.trtValid && this.props.aquas.length > 0)) {
            this.props.addAlRow(this.props.noteId, 'MLAQUATICS', 'XLAQ', 'XLAQNO', 'XLAQXLNO', this.props.xlno, 'NEW_XLAQNO');
            this.setState({ showWarning: false });
        } else if (!this.props.trtValid && this.props.aquas.length === 0) {
            this.setState({ showWarning: true });
        }
    }

    componentDidUpdate() {
        if (this.props.aquas.length === 0 && this.props.time !== null) {
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMEAQUA', 'XLTIMEAQUAASSIST', 'XLTIMEAQUATHERAPIST']);
        }
    }

    confirmPending() {
        this.props.addAlRow(this.props.noteId, 'MLAQUATICS', 'XLAQ', 'XLAQNO', 'XLAQXLNO', this.props.xlno, 'NEW_XLAQNO');
        this.setState({ showWarning: false });
    }

    remove() {
        this.setState({ showWarning: false });
    }

    render() {
        return (
            <AlSection
                id='al_aqua'
                name='Aquatics (97113)'
                timeField='XLTIMEAQUA'
                timeRequired={this.props.containsPerformed && this.props.time === null ? true : false}
                timeVisible={this.props.aquas.length > 0 ? true : false}
                trackAssist={this.props.trackAssist}
                onAdd={() => this.add()}
                className={this.props.className}
            >

                {this.state.showWarning &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }

                {this.props.aquas.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>Activity</span>
                        <span className={styles.col2_header}>Description</span>
                        <span className={styles.col3_header}>Sets/Reps/Weight/Time</span>
                        <span className={styles.col4_header}>Performed</span>
                    </div>
                }

                {Object.keys(this.props.aquas)
                    .map(key => {
                        const result = this.props.aquas[key];
                        return (
                            <AlAquaRow key={result.XLAQNO} id={result.XLAQNO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let trackAssist = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;
    let containsPerformed = state.entities.notes.MLAQUATICS &&
        Object.keys(state.entities.notes.MLAQUATICS)
            .filter(key => {
                return (state.entities.notes.MLAQUATICS[key].XLAQXLNO === xlno && state.entities.notes.MLAQUATICS[key].XLAQPERFORMED)
            }).length > 0 ? true : false;


    return {
        noteId,
        xlno,
        time: state.entities.notes.MLEXLOG[xlno].XLTIMEAQUA,
        trtValid: codeValidForAdmit(epno, '97113'),
        aquas: Object.keys(state.entities.notes.MLAQUATICS)
            .filter(key => {
                return (state.entities.notes.MLAQUATICS[key].XLAQXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLAQUATICS[a].XLAQNO - state.entities.notes.MLAQUATICS[b].XLAQNO)
            .map(key => state.entities.notes.MLAQUATICS[key]),
        trackAssist,
        isLicensed,
        containsPerformed,
    };
}

const connectedAlAqua = connect(mapStateToProps, mapDispatchToProps)(AlAqua);
export { connectedAlAqua as AlAqua };

